import Hero from "../components/Hero";
import TrendingBanner from "../components/TrendingBanner";
import AccessFeatures from "../components/AccessFeatures";
import RequestCallback from "../components/RequestCallback";

function Home() {
  return (
    <>
      <Hero />
      <TrendingBanner />
      <AccessFeatures />
      <RequestCallback />
    </>
  );
}

export default Home;
